module.exports = __webpack_public_path__ + "img/dio.991c7a5e.png";